import { useCallback, useMemo } from "react";

import type { VoucherForCampaignUserItemInput } from "@/lib/gql/__generated__/graphql";

import { useMarketingCampaignFormModelContext } from "../../../context";

export const useCampaignList = () => {
	const { viewModel, onSetViewModel } = useMarketingCampaignFormModelContext();
	const { voucherGiftList } = viewModel;

	const onAddVoucherGiftListItemsFromCSV = useCallback(
		(input: VoucherForCampaignUserItemInput[]) => {
			const newItems = input.map((item) => {
				return {
					guestEmail: {
						isEdited: true,
						value: item.guestEmail ?? "",
					},
					guestName: {
						isEdited: true,
						value: item.guestName,
					},
					guestTel: {
						isEdited: true,
						value: item.guestTel,
					},
				};
			});

			const newList = [...voucherGiftList.value, ...newItems].filter((_, idx) => idx < 30);

			onSetViewModel([
				{
					key: "voucherGiftList",
					value: {
						isEdited: true,
						hasError: false,
						value: newList,
					},
				},
			]);
		},
		[onSetViewModel, voucherGiftList.value],
	);

	const canAppendVoucherGiftListItem = useMemo(
		() => voucherGiftList.value.length <= 30,
		[voucherGiftList.value.length],
	);

	const onAddVoucherGiftListItem = useCallback(
		(item: VoucherForCampaignUserItemInput) => {
			const itemForAutoGenerator = {
				guestTel: {
					isEdited: true,
					value: item.guestTel,
				},
				guestEmail: {
					isEdited: true,
					value: item.guestEmail || undefined,
				},
				guestName: {
					isEdited: true,
					value: item.guestName,
				},
			};

			const newList = [...voucherGiftList.value, itemForAutoGenerator];

			onSetViewModel([
				{
					key: "voucherGiftList",
					value: {
						isEdited: true,
						hasError: false,
						value: newList,
					},
				},
			]);
		},
		[onSetViewModel, voucherGiftList.value],
	);

	const onRemoveVoucherGiftListItemByIndex = useCallback(
		(index: number) => {
			const newList = voucherGiftList.value.filter((_, i) => i !== index);

			onSetViewModel([
				{
					key: "voucherGiftList",
					value: {
						isEdited: true,
						hasError: false,
						value: newList,
					},
				},
			]);
		},
		[onSetViewModel, voucherGiftList.value],
	);

	return {
		voucherGiftList,

		onAddVoucherGiftListItemsFromCSV,

		canAppendVoucherGiftListItem,
		onAddVoucherGiftListItem,

		onRemoveVoucherGiftListItemByIndex,
	};
};
